import { useEffect } from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { getMachinePersistedState } from '../../dietaryRestrictionsMachine.utils';

import type { useInterpret } from '@xstate/react';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Reads the persisted context of a dietary restrictions from Async storage
 */
export const useDietaryRestrictionsFromAsyncStorage = <Interpreter extends XStateInterpreter>(
  interpreter: Interpreter,
) => {
  const isRemoteDietaryRestrictionsEnabled = useFeatureFlag(
    'CELS-3623-remote-dietary-restrictions-enabled',
  );

  useEffect(() => {
    (async () => {
      if (isRemoteDietaryRestrictionsEnabled) return;

      const persistedContext = await getMachinePersistedState();

      if (!persistedContext) return;

      const restrictions = JSON.parse(persistedContext);

      interpreter.send({ type: 'SET_RESTRICTIONS', restrictions });
    })();
  }, [interpreter, isRemoteDietaryRestrictionsEnabled]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type XStateInterpreter = ReturnType<typeof useInterpret>;
